import DemoCarModel from '../../../../../view/pages/posm/models/DemoCar.model';
import { DemoCarsService } from '../../../api/demo-cars';

// State
const state = {
  demoCars: [],
  totalItems: 0,
  totalPages: 0,
  currentPage: 1,
  isLoading: false,
  error: null,
  selectedDemoCar: null,
};

// Getters
const getters = {
  getDemoCars: (state) => state.demoCars,
  getTotalItems: (state) => state.totalItems,
  getTotalPages: (state) => state.totalPages,
  getCurrentPage: (state) => state.currentPage,
  isLoading: (state) => state.isLoading,
  getError: (state) => state.error,
  getSelectedDemoCar: (state) => state.selectedDemoCar,
};

// Actions
const actions = {
  /**
   * Lấy danh sách xe demo
   * @param {Object} context - Vuex context
   * @param {Object} payload - Tham số lọc và phân trang
   */
  async fetchDemoCars({ commit }, payload) {
    commit('SET_LOADING', true);
    try {
      const { data } = await DemoCarsService.getList(payload);
      const demoCars = DemoCarModel.fromJsonArray(data.data.data);
      commit('SET_DEMO_CARS', demoCars);
      commit('SET_TOTAL_ITEMS', data.data.paginations.total);
      commit('SET_TOTAL_PAGES', data.data.paginations.totalPages);
      commit('SET_CURRENT_PAGE', payload.page || 1);
      return demoCars;
    } catch (error) {
      commit('SET_ERROR', 'Lỗi khi tải dữ liệu');
      console.error(error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Lấy thông tin chi tiết của một xe demo
   * @param {Object} context - Vuex context
   * @param {string} id - ID của xe demo
   */
  async fetchDemoCarById({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const { data } = await DemoCarsService.getById(id);
      const demoCar = DemoCarModel.fromJson(data.data);
      commit('SET_SELECTED_DEMO_CAR', demoCar);
    } catch (error) {
      commit('SET_ERROR', 'Lỗi khi tải dữ liệu');
      console.error(error);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Tạo mới xe demo
   * @param {Object} context - Vuex context
   * @param {Object} payload - Dữ liệu xe demo
   */
  async createDemoCar({ commit }, payload) {
    commit('SET_LOADING', true);
    try {
      const { data } = await DemoCarsService.create(payload);
      return {
        success: true,
        message: data.message || 'Thêm mới thành công',
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Lỗi khi thêm mới';
      commit('SET_ERROR', errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Cập nhật thông tin xe demo
   * @param {Object} context - Vuex context
   * @param {Object} payload - Dữ liệu cập nhật
   */
  async updateDemoCar({ commit }, payload) {
    commit('SET_LOADING', true);
    try {
      const { id, ...data } = payload;
      const response = await DemoCarsService.update(id, data);
      return {
        success: true,
        message: response.data.message || 'Cập nhật thành công',
      };
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Lỗi khi cập nhật';
      commit('SET_ERROR', errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      commit('SET_LOADING', false);
    }
  },

  /**
   * Xóa xe demo
   * @param {Object} context - Vuex context
   * @param {string} id - ID của xe demo
   */
  async deleteDemoCar({ commit }, id) {
    commit('SET_LOADING', true);
    try {
      const { data } = await DemoCarsService.delete(id);
      return { success: true, message: data.message || 'Xóa thành công' };
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Lỗi khi xóa';
      commit('SET_ERROR', errorMessage);
      return { success: false, message: errorMessage };
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

// Mutations
const mutations = {
  SET_DEMO_CARS(state, demoCars) {
    state.demoCars = demoCars;
  },
  SET_TOTAL_ITEMS(state, totalItems) {
    state.totalItems = totalItems;
  },
  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.currentPage = currentPage;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_SELECTED_DEMO_CAR(state, demoCar) {
    state.selectedDemoCar = demoCar;
  },
  RESET_STATE(state) {
    state.demoCars = [];
    state.totalItems = 0;
    state.totalPages = 0;
    state.currentPage = 1;
    state.isLoading = false;
    state.error = null;
    state.selectedDemoCar = null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
